export default "__VITE_ASSET__BGVLBQES__"